import { cva } from "class-variance-authority";

export const variantes = cva(
  // Estilos base compartidos por todas las variantes
  "py-3 rounded-2xl font-bold text-base transition inline-flex items-center justify-center gap-2 whitespace-nowrap shrink-0 cursor-pointer pointer  outline-none [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-[var(--ring)] focus-visible:ring-[var(--ring)]/50 focus-visible:ring-[3px] aria-invalid:border-[var(--destructive)] aria-invalid:ring-[var(--destructive)]/20 disabled:bg-primary-disabled disabled:text-gray-800 disabled:cursor-not-allowed disabled:pointer-events-none active:scale-[0.98] uppercase shadow-md shadow-black/40",
  {
    variants: {
      variant: {
        default: "bg-[#bbc8fe] text-white hover:bg-[#bbc8fe]/90",
        danger:
          "bg-[var(--destructive)] text-white hover:brightness-110 focus-visible:ring-[var(--destructive)]/20",
        outline:
          "border bg-transparent text-[var(--foreground)] hover:brightness-110",
        primary: "bg-[#5b3bea] text-white hover:bg-[#4a2fcc]",
        secondary:
          "bg-[var(--secondary)] text-[var(--secondary-foreground)] hover:brightness-110",
        link: "text-[var(--primary)] underline-offset-4 hover:underline shadow-none",
        headerAction:
          "bg-(--primary) text-(--secondary-foreground) hover:brightness-110",
        icon: "bg-transparent shadow-none hover:brightness-110",
      },
      size: {
        default: "py-4 px-10",
        sm: "py-2 px-4 text-sm",
        lg: "py-4 text-lg",
        full: "w-full py-3",
        icon: "h-auto w-auto rounded-full p-0",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
